<template>
	<v-app id="inspire">
		<router-view></router-view>
		<v-footer
			color="indigo"
			app
		>
			<span class="white--text">Closeapp &copy; 2019</span>
		</v-footer>
	</v-app>
</template>

<script>
export default {
	name: "app"
};
</script>
